import React, { useState } from 'react';

const Certifications = ({ certifications, onRemove, onEdit, onAddNew }) => {
  return (
    <div className="form-section">
      <div className="section-header">
        <h2 className="section-title purple">Certifications</h2>
        <button
          onClick={onAddNew}
          className="btn btn-primary"
        >
          Add Certification
        </button>
      </div>
      {certifications.map((certification, index) => (
        <div key={index} className="certification-card">
          <div className="certification-card-content">
            <div className="certification-info">
              <h3 className="certification-title">{certification.name}</h3>
              <p className="certification-org">{certification.issuingOrganization}</p>
              <p className="certification-date">
                Issued: {certification.issueDate}
                {certification.expiryDate && ` | Expires: ${certification.expiryDate}`}
              </p>
              {certification.credentialId && (
                <p className="certification-id">Credential ID: {certification.credentialId}</p>
              )}
              {certification.description && (
                <p className="certification-description">{certification.description}</p>
              )}
              {certification.credentialUrl && (
                <a
                  href={certification.credentialUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="certification-link"
                >
                  View Credential
                </a>
              )}
            </div>
            <div className="certification-actions">
              <button
                onClick={() => onEdit(certification, index)}
                className="btn btn-secondary btn-small"
              >
                Edit
              </button>
              <button
                onClick={() => onRemove(index)}
                className="btn btn-danger btn-small"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Certifications; 